import React, { useEffect, useState } from "react";
import {
  server_post_data,
  maintainance_car_data,
  upload_image_to_folder,
} from "../../ServiceConnection/serviceconnection";
import {
  handleError,
  handleNumbersChange,
} from "../../CommonJquery/CommonJquery";
import { X } from "lucide-react";
const SafetyChecks = ({
  onNext,
  onBack,
  cardata,
  MaintainanceData,
  BookingData,
  ImageLink,
  setCount,
  FromComeData,
}) => {
  const [safetyData, setSafetyData] = useState({
    dashboardWarning: "",
    hornFunctionality: "",
    phoneCharging: "",
    wiperBlades: "",
    wiperWorking: "",
    otherDashboardWarning: "",
    dashboardImg: "",
    dashboardImg_name: "",
    odometerReading: "",
  });

  const dashboardWarningOptions = [
    { value: "noDashLight", label: "No Dash Light" },
    { value: "checkEngine", label: "Check Engine" },
    { value: "tireWarning", label: "Tire Warning" },
    { value: "other", label: "Other (Specify)" },
  ];

  useEffect(() => {
    const dashboardSafety = MaintainanceData.dashboard_safety;
    const isExist =
      dashboardSafety &&
      dashboardWarningOptions.some((item) => item.value === dashboardSafety);
    setSafetyData({
      dashboardWarning: dashboardSafety
        ? isExist
          ? dashboardSafety
          : "other"
        : "",
      hornFunctionality: MaintainanceData.horn_working,
      phoneCharging: MaintainanceData.phone_charging,
      wiperBlades: MaintainanceData.wiper_blade,
      wiperWorking: MaintainanceData.wiper_working,
      otherDashboardWarning: dashboardSafety && !isExist ? dashboardSafety : "",
      dashboardImg_name: MaintainanceData.dashboard_image,
    });
  }, [MaintainanceData]);

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [errors, setErrors] = useState({
    dashboardWarning: false,
    hornFunctionality: false,
    phoneCharging: false,
    wiperBlades: false,
    wiperWorking: false,
    otherDashboardWarning: false,
    dashboardImg: false,
  });

  const handleFieldChange = (field, value) => {
    setSafetyData({ ...safetyData, [field]: value });
    if (value) {
      setErrors({ ...errors, [field]: false });
    }
  };

  const handleDashboardImgUpload = (e) => {
    const file = e.target.files[0];

    // Check if the file is valid (PNG, JPG, JPEG)
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      uploadImageserver(file);
    } else {
      setSafetyData((prevState) => ({
        ...prevState,
        dashboardImg: "",
        dashboardImg_name: "",
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        dashboardImg: "Please upload a valid image (PNG, JPG, JPEG)", // Error message
      }));
    }
  };

  const uploadImageserver = async (file) => {
    const fd = new FormData();
    fd.append("image", file);
    await server_post_data(upload_image_to_folder, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setSafetyData((prevState) => ({
            ...prevState,
            dashboardImg: file,
            dashboardImg_name: Response.data.message.image_uploaded,
          }));
          setErrors((prevErrors) => ({
            ...prevErrors,
            dashboardImg: false,
          }));
        }
      })
      .catch((error) => {});
  };

  const handleRemoveDashboardImg = () => {
    setSafetyData((prevState) => ({
      ...prevState,
      dashboardImg: "",
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      dashboardImg: false,
    }));
    document.getElementById("dashboardImgInput").value = "";
  };

  const validateSafetyData = (safetyData) => {
    let hasError = false;
    const newErrors = {};
    Object.keys(safetyData).forEach((key) => {
      if (key === "dashboardWarning") {
        if (!safetyData[key]) {
          newErrors[key] = true;
          hasError = true;
        } else if (safetyData[key] !== "other") {
          delete newErrors.otherDashboardWarning;
        }
      } else if (!safetyData[key] && key !== "otherDashboardWarning") {
        newErrors[key] = true;
        hasError = true;
      }
    });
    if (
      safetyData.dashboardWarning === "other" &&
      !safetyData.otherDashboardWarning
    ) {
      newErrors.otherDashboardWarning = true;
      hasError = true;
    }
    // Validate the image field (dashboardImg)
    if (!safetyData.dashboardImg && safetyData.dashboardImg_name == "") {
      newErrors.dashboardImg = true;
      hasError = true;
    }

    if (!safetyData.odometerReading && safetyData.odometerReading === "") {
      errors.odometerReading = "Please enter Odometer Reading ";
    }

    return { hasError, newErrors };
  };

  const handleNext = async () => {
    const { hasError, newErrors } = validateSafetyData(safetyData);
    setErrors(newErrors);
    if (!hasError) {
      setshowLoaderAdmin(true);
      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
      fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id  || 0);
      fd.append("horn_working", safetyData.hornFunctionality);
      fd.append("phone_charging", safetyData.phoneCharging);
      fd.append("wiper_blade", safetyData.wiperBlades);
      fd.append("wiper_working", safetyData.wiperWorking);
      fd.append("dashboard_image", safetyData.dashboardImg_name);
      if (
        safetyData.otherDashboardWarning !== "" &&
        safetyData.otherDashboardWarning !== undefined &&
        safetyData.dashboardWarning === "other"
      ) {
        fd.append("dashboard_safety", safetyData.otherDashboardWarning);
      } else {
        fd.append("dashboard_safety", safetyData.dashboardWarning);
      }
      fd.append("odo_metter", safetyData.odometerReading);
      if (safetyData.dashboardImg) {
        fd.append("dashboard_img", safetyData.dashboardImg);
      }
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("step_for_maintenance", 6);
      fd.append("save_or_edit_type", FromComeData);
      await server_post_data(maintainance_car_data, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            onNext();
            setCount(7);
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
      // onNext();
    }
  };

  return (
    <>
      <div className="safety-checks-container">
        <h3 className="section-title text-primary">
          Dashboard & Safety Checks <span className="mandory_field">*</span>
        </h3>

        {/* Dashboard Warning Lights Section */}
        <div className="section">
          <h5>
            Dashboard Warning Lights: <span className="mandory_field">*</span>
          </h5>
          {errors.dashboardWarning && (
            <span className="error-text">This field is required</span>
          )}
          <div className="row">
            {dashboardWarningOptions.map((option) => (
              <div key={option.value} className="col-md-3 mb-2">
                <button
                  className={`btn btn-outline-secondary w-100 ${
                    safetyData.dashboardWarning === option.value ? "active" : ""
                  }`}
                  onClick={() =>
                    handleFieldChange("dashboardWarning", option.value)
                  }
                >
                  {option.label}
                </button>
              </div>
            ))}
          </div>
          {safetyData.dashboardWarning === "other" && (
            <div className="col-md-6 mt-3">
              <input
                type="text"
                className="form-control custmInput"
                value={safetyData.otherDashboardWarning}
                onChange={(e) =>
                  handleFieldChange("otherDashboardWarning", e.target.value)
                }
                placeholder="Specify warning light"
              />
              {errors.otherDashboardWarning && (
                <span className="error-text">This field is required</span>
              )}
            </div>
          )}
        </div>
        <div className="section">
          <h5>
            Picture of Dashboard: <span className="mandory_field">*</span>
          </h5>
          {errors.dashboardImg && (
            <span className="error-text">This field is required</span>
          )}
          <div className="col-md-6 mb-2">
            <input
              id="dashboardImgInput"
              className="form-control"
              type="file"
              onChange={handleDashboardImgUpload}
              accept=".png, .jpeg, .jpg"
            />
            {safetyData.dashboardImg_name && (
              <div className="oil_close_cap_div">
                <img
                  src={ImageLink + safetyData.dashboardImg_name}
                  alt="Uploaded Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />

                <X
                  className="removeBttn"
                  size={18}
                  onClick={handleRemoveDashboardImg}
                />
              </div>
            )}
          </div>
        </div>

        {/* Odometer Reading */}
        <div className="section">
          <h5>
            Odometer Reading: <span className="mandory_field">*</span>
          </h5>
          {errors.odometerReading && (
            <span className="error-text">{errors.odometerReading}</span>
          )}
          <input
            className="form-control"
            type="text"
            value={safetyData.odometerReading}
            maxLength={6}
            onChange={(e) =>
              setSafetyData((prev) => ({
                ...prev,
                odometerReading: e.target.value,
              }))
            }
            // onKeyDown={handleNumbersChange}
            onInput={handleNumbersChange}
            placeholder="Odometer Reading"
          />
        </div>
        {/* Horn Functionality Section */}
        <div className="section">
          <h5>
            Horn Functionality: <span className="mandory_field">*</span>
          </h5>
          {errors.hornFunctionality && (
            <span className="error-text">This field is required</span>
          )}
          <div className="row">
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.hornFunctionality === "working"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() =>
                  handleFieldChange("hornFunctionality", "working")
                }
              >
                Working
              </button>
            </div>
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.hornFunctionality === "notWorking"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() =>
                  handleFieldChange("hornFunctionality", "notWorking")
                }
              >
                Not Working
              </button>
            </div>
          </div>
        </div>

        {/* Phone Charging Section */}
        <div className="section">
          <h5>
            Phone Charging: <span className="mandory_field">*</span>
          </h5>
          {errors.phoneCharging && (
            <span className="error-text">This field is required</span>
          )}
          <div className="row">
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.phoneCharging === "working"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() => handleFieldChange("phoneCharging", "working")}
              >
                Working
              </button>
            </div>
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.phoneCharging === "notWorking"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleFieldChange("phoneCharging", "notWorking")}
              >
                Not Working
              </button>
            </div>
          </div>
        </div>

        {/* Wiper Blades Section */}
        <div className="section">
          <h5>
            Wiper Blades: <span className="mandory_field">*</span>
          </h5>
          {errors.wiperBlades && (
            <span className="error-text">This field is required</span>
          )}
          <div className="row">
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.wiperBlades === "good" ? "active goodActive" : ""
                }`}
                onClick={() => handleFieldChange("wiperBlades", "good")}
              >
                Good
              </button>
            </div>
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.wiperBlades === "changed"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleFieldChange("wiperBlades", "changed")}
              >
                Changed
              </button>
            </div>
          </div>
        </div>

        {/* Wiper Working Section */}
        <div className="section">
          <h5>
            Wiper Working: <span className="mandory_field">*</span>
          </h5>
          {errors.wiperWorking && (
            <span className="error-text">This field is required</span>
          )}
          <div className="row">
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.wiperWorking === "yes" ? "active goodActive" : ""
                }`}
                onClick={() => handleFieldChange("wiperWorking", "yes")}
              >
                Yes
              </button>
            </div>
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  safetyData.wiperWorking === "no"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleFieldChange("wiperWorking", "no")}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>

        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default SafetyChecks;
